// Locale State

export default {
  isRtl: false,
  currentLocale: '',
  locales: [
    { text: 'English', value: 'en', dir: 'ltr' },
    { text: 'Arabic', value: 'ar', dir: 'rtl' },
    { text: 'Kurdish', value: 'ckb', dir: 'rtl' }
  ],
  countriesList: []
}
